import { render, staticRenderFns } from "./MessageLogsTab.vue?vue&type=template&id=caafc48c&"
import script from "./MessageLogsTab.vue?vue&type=script&lang=js&"
export * from "./MessageLogsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports